import Header from './Header'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'

import * as userSelectors from '../../selectors/user'
import * as authSelectors from '../../selectors/auth'

const mapStateToProps = state => ({
  userInitials: userSelectors.getUserInitials(state),
  userIsLoggedIn: authSelectors.userIsLoggedIn(state)
})

const mapDispatchToProps = null

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Header)



// WEBPACK FOOTER //
// ./src/modules/Header/index.js